import React from "react";
import { useSelector } from "react-redux";
import Card from "../../../../shared/components/ui/card/Card";
import Icon from "../../../../shared/components/ui/icons/Icon";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import classes from "./FixedPermissionsList.module.css";

const FixedPermissionsList = () => {
    const { texts } = useSelector((state) => state.translate);

    const fixedRoles = [texts.schoolPrincipal, texts.technologyCoordinators];

    return (
        <Card className={classes.Card}>
            <div className={classes.CardHeader}>
                <p className={classes.CardTitle}>{texts.fixedPermissionsInSystem}</p>
                <p className={classes.CardSubtitle}>{texts.fixedPermissionsInSystemSubtitle}</p>
            </div>
            <div className={classes.Table}>
                <div className={classes.TableHeader}>
                    <span className={classes.HeaderName}>{texts.name}</span>
                    <span className={classes.HeaderActions}>{texts.actions}</span>
                </div>
                <div className={classes.TableBody}>
                    {fixedRoles.map((role) => (
                        <div key={role} className={classes.Row}>
                            <span className={classes.RoleName}>{role}</span>
                            <div className={classes.ActionsCell}>
                                <Icon name={iconsList.lock} size="24px" color="#626262" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Card>
    );
};

export default FixedPermissionsList;
